export default __webpack_public_path__ + "media/zurb/img/about/team-profiles/daniel-profile-6a6f83a746ff0dd64725eeba256fc7fa.png";